import { useSignUpStepStoreValue } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpStepStoreValue";
import {
  Step,
  stepKeyToPathMap,
} from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import { trackSignupRevampFieldChangeKeyboardInput } from "@faire/web-api--source/events/signup/keyboardInput/revampFieldChange";
import { trackSignupRevampPageSubmit } from "@faire/web-api--source/events/signup/submit/revampPage";
import { trackSignupRevampPageView } from "@faire/web-api--source/events/signup/view/revampPage";
import { useCallback } from "react";

export const useSignUpEventTracker = (currentStep: Step) => {
  const { signUpType } = useSignUpStepStoreValue();

  const trackView = useCallback(() => {
    trackSignupRevampPageView(
      stepKeyToPathMap[currentStep](),
      currentStep,
      signUpType
    );
  }, [signUpType, currentStep]);

  const trackSubmit = useCallback(
    (step?: Step) => {
      trackSignupRevampPageSubmit(
        stepKeyToPathMap[step ?? currentStep](),
        step ?? currentStep,
        signUpType
      );
    },
    [signUpType, currentStep]
  );

  const trackFieldValue = useCallback(
    (fieldName: string, fieldValue: string) => {
      trackSignupRevampFieldChangeKeyboardInput(
        fieldName,
        fieldValue,
        currentStep,
        signUpType
      );
    },
    [signUpType, currentStep]
  );

  return { trackView, trackSubmit, trackFieldValue };
};
